import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { storableError } from '../../util/errors';
import { fetchCurrentUser, updateCurrentUserProfile } from '../../ducks/user.duck';

export const saveSellerVerificationDraftThunk = createAsyncThunk(
  'SellerVerificationPage/saveDraft',
  async ({ privateData }, { dispatch, rejectWithValue }) => {
    try {
      await dispatch(updateCurrentUserProfile({ privateData }));
      return true;
    } catch (error) {
      return rejectWithValue(storableError(error));
    }
  }
);

export const submitSellerVerificationThunk = createAsyncThunk(
  'SellerVerificationPage/submit',
  async ({ privateData }, { dispatch, rejectWithValue }) => {
    try {
      await dispatch(updateCurrentUserProfile({ privateData }));
      return true;
    } catch (error) {
      return rejectWithValue(storableError(error));
    }
  }
);

const sellerVerificationPageSlice = createSlice({
  name: 'SellerVerificationPage',
  initialState: {
    saveDraftInProgress: false,
    submitInProgress: false,
    error: null,
    successMessage: null,
  },
  reducers: {
    clearFeedback: state => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(saveSellerVerificationDraftThunk.pending, state => {
        state.saveDraftInProgress = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(saveSellerVerificationDraftThunk.fulfilled, state => {
        state.saveDraftInProgress = false;
        state.successMessage = 'Draft saved.';
      })
      .addCase(saveSellerVerificationDraftThunk.rejected, (state, action) => {
        state.saveDraftInProgress = false;
        state.error = action.payload;
      })
      .addCase(submitSellerVerificationThunk.pending, state => {
        state.submitInProgress = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(submitSellerVerificationThunk.fulfilled, state => {
        state.submitInProgress = false;
        state.successMessage = 'Submitted for approval.';
      })
      .addCase(submitSellerVerificationThunk.rejected, (state, action) => {
        state.submitInProgress = false;
        state.error = action.payload;
      });
  },
});

export const { clearFeedback } = sellerVerificationPageSlice.actions;
export default sellerVerificationPageSlice.reducer;

export const saveSellerVerificationDraft = params => dispatch => {
  return dispatch(saveSellerVerificationDraftThunk(params)).unwrap();
};

export const submitSellerVerification = params => dispatch => {
  return dispatch(submitSellerVerificationThunk(params)).unwrap();
};

export const loadData = () => {
  return fetchCurrentUser();
};
